import React, { createContext, useContext, useState, useEffect } from "react";

const SearchContext = createContext(null);

export const SearchProvider = ({ children }) => {
  const [query, setQuery] = useState("");

  const [sectionId, setSectionId] = useState(() => {
    try {
      const stored = localStorage.getItem("sectionId"); // Get raw value from localStorage
      console.log("Raw sectionId from localStorage:", stored);

      // Parse stored JSON, or fallback to null
      const parsed = stored && stored !== "undefined" ? JSON.parse(stored) : null;
      console.log("Parsed sectionId:", parsed);

      return parsed;
    } catch (error) {
      console.error("Error parsing sectionId from localStorage:", error);
      return null;
    }
  });

  // Save to localStorage whenever sectionId changes
  useEffect(() => {
    if (sectionId !== null) {
      console.log("Saving sectionId to localStorage:", sectionId);
      try {
        localStorage.setItem("sectionId", JSON.stringify(sectionId)); // ✅ Always stringify
      } catch (error) {
        console.error("Error saving sectionId to localStorage:", error);
      }
    } else {
      // Optional: remove key if null
      localStorage.removeItem("sectionId");
      // console.log("Removed sectionId from localStorage because it's null");
    }
  }, [sectionId]);

  return (
    <SearchContext.Provider value={{ query, setQuery, sectionId, setSectionId }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => useContext(SearchContext);
